import React, { useEffect, useCallback, useState} from 'react';
import {lstorage} from 'utils/lstorage.js';
import Tone from 'tone';
import Dropdown from 'react-dropdown';
import {connect} from 'react-redux';
import {
    PLAYBACK,
    BALANCED,
    INTERACTIVE
} from 'constants/latency-modes.js';;

const SampeRateChooser = (props) => { 
    let [latencyHint, setLatencyHint] = useState(props.latencyHint || INTERACTIVE);
    let [needsReload, setNeedsReload] = useState(false);

    const onChange = useCallback((hint) => {
        hint = hint.value;
        lstorage.setItem("latencyHint", hint);
        setLatencyHint(hint);
        props.sequencerEngine.save("Test", "PUBLIC", false);
        setNeedsReload(true);
    }, [setLatencyHint, needsReload]);

    return (
        <div className="sample-rate-chooser">
          <div className="dropdown-title">
            Latency Hint:
          </div>
          <Dropdown
            className='audio-input-chooser-dropdown'
            controlClassName='audio-input-chooser-dropdown'
            arrowClassName='osc-type-arrow-dropdown'
            options={OPTIONS}
            onChange={onChange}
            value={getOption(latencyHint)}
            placeholder="Audio Input" />
          {needsReload ?
           <div className="needs-reload">
             Reload page to use new latency hint
           </div> : ''}
        </div>);
}

const OPTIONS = [INTERACTIVE, BALANCED, PLAYBACK]
      .map(
          x => ({
              label: x,
              value: x
          }));

const getOption = (sampleRate) => ({
    label: sampleRate,
    value: sampleRate
});

const mapStateToProps = (state, props) => {
  return {
      latencyHint: props.sequencerEngine.latencyHint
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SampeRateChooser);
